
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import PrintIcon from '@mui/icons-material/Print';
import { IconButton, Stack } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import Tooltip from "@mui/material/Tooltip";
import jsPDF from "jspdf";
import "jspdf-autotable";



const WorkOrderRefreshExportButtons = ({
    refData,
    exportPDF,
    onPrint,
    exportToExcel,
    disablePdfPrinter = false
}) => {
    const gridApi = refData;
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === "Escape") {
            setOpen(false);
        }
    }

    const prevOpen = React.useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

  


    return (
        <>
            <Stack direction={"row"} alignItems={"flex-end"}>
                <Tooltip
                    title="Export"
                    placement="bottom"
                    arrow
                    disableFocusListener
                    disableInteractive
                >
                    <IconButton
                        variant="contained"
                        ref={anchorRef}
                        onClick={handleToggle}
                    >
                        <SaveAltRoundedIcon />
                    </IconButton>
                </Tooltip>
            </Stack>

            { !disablePdfPrinter && <Stack direction={"row"} alignItems={"flex-end"}>
                <Tooltip
                    title="Print"
                    placement="bottom"
                    arrow
                    disableFocusListener
                    disableInteractive
                >
                    <IconButton onClick={onPrint}>
                        <PrintIcon />
                    </IconButton>
                </Tooltip>

            </Stack>}

            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
                sx={{ zIndex: 5, width: 100 }}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === "bottom-start" ? "left top" : "left bottom",
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    autoFocusItem={open}
                                    id="composition-menu"
                                    aria-labelledby="composition-button"
                                    onKeyDown={handleListKeyDown}
                                >


                                    <>
                                        { !disablePdfPrinter && <MenuItem onClick={exportPDF}>pdf</MenuItem>}
                                        <MenuItem onClick={exportToExcel}>Excel</MenuItem>
                                    </>


                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    );
};

export default WorkOrderRefreshExportButtons;
